import { useRef, useCallback } from 'react';

/**
 * Returns a getter and setter to manage a value.
 * The returned functions are stable and don't change in every render.
 * @template T
 * @param {T | () => T} [initialValue] The initial value or a function to get the initial value
 * @returns {[get: () => T, set: (value: T | ((current: T) => T)) => void ]}
 */
function useGetAndSet(initialValue) {
  /** @type {import('react').MutableRefObject<T>} */
  var ref = useRef();
  var initialized = useRef(false);
  if (!initialized.current) {
    ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
    initialized.current = true;
  }
  var get = useCallback(function () {
    return ref.current;
  }, []);
  var set = useCallback(function (value) {
    ref.current = typeof value === 'function' ? value(ref.current) : value;
  }, []);
  return [get, set];
}

export { useGetAndSet };
//# sourceMappingURL=useGetAndSet.js.map
